export interface FormQuestionType {
  code: string;
  name: string;
}

export const formQuestionTypes: FormQuestionType[] = [
  { code: 'text', name: 'Question (Textbox)' },
  { code: 'boolean', name: 'Boolean (Yes/No)' },
  { code: 'choice', name: 'Dropdown (Multiselect)' },
  { code: 'file', name: 'File upload' },
];

export function formQuestionTypeToName(arg: string): any {
  const questionType = formQuestionTypes.find((type) => type.code === arg);
  if (questionType) {
    return questionType.name;
  }
  return arg;
}
